import { HttpClient, HttpHeaders } from "@angular/common/http";
import { EventEmitter, Injectable } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";
import { ApiRequestService } from "src/app/services/api-request/api-request.service";

@Injectable({
    providedIn: 'root'
  })
export class ConsumerImmersionService{

    // public GET_REQUEST_LIST = environment.apiUrl + '/v2/ci/requests';
    // public CREATE_REQUEST = environment.apiUrl + '/v2/ci/request';
    // public UPDATE_REQUEST = environment.apiUrl + '/v2/ci/request';
    // public REQUEST_CREDIT = environment.apiUrl + '/v2/api/ci-credit-req';
    // public GET_REQUEST_OWNER_LIST = environment.apiUrl + '/v2/api/ci-user';
    // public GET_PLAYER_URL = environment.apiUrl + '/v2/ci/getmeetingurl';
    // public GET_INTERVIEW_URL = environment.apiUrl + '/v2/ci/interviews';
    // public GET_TRANSECTION_URL = environment.apiUrl + '/v2/api/ci-credit-history';
    // public GET_DROPDOWN = environment.apiUrl + '/v2/ci/getFormConfig';
    // public SET_SANCTION = environment.apiUrl + '/v2/ci/sanctionRequest/';
    public GET_REQUEST_LIST = '/v2/ci/requests';
    public GET_REQUEST_QUOTE_APPROVE = '/v2/ci/approveFeesQuote';
    public CREATE_REQUEST = '/v2/ci/request';
    public UPDATE_REQUEST = '/v2/ci/request';
    public REQUEST_CREDIT = '/v2/api/ci-credit-req';
    public GET_REQUEST_OWNER_LIST = '/v2/api/ci-user';
    public GET_PLAYER_URL = '/v2/ci/getmeetingurl';
    public GET_INTERVIEW_URL = '/v2/ci/interviews';
    public GET_TRANSECTION_URL = '/v2/api/ci-credit-history';
    public GET_DROPDOWN = '/v2/ci/getFormConfig';
    public SET_SANCTION = '/v2/ci/sanctionRequest';
    public isSearchShown: boolean = false;
    public onRequestListEventEmit: EventEmitter<string> = new EventEmitter<string>();
    public searchValue: string = '';

    
    

    // public SET_PONUM = '/v2/ci/sanctionRequest';


    public isOpen: boolean = false;
    public isLoading: boolean = false;
    public sidenav2Open: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
    public httpPostOptions = {
        headers: new HttpHeaders().set('Content-Type', 'application/json'),
        withCredentials: true,
        params:{}
      };

    constructor(private http:HttpClient, private apiRequest: ApiRequestService) {
        this.sidenav2Open.subscribe((value) => { this.isOpen = value; });
    }


    onSearchChange(searchValue: string){
      this.searchValue = searchValue;
      this.onRequestListEventEmit.emit(searchValue);
    }

    

    getRequestList():Observable<any>{
        if(this.searchValue && this.searchValue.length >=2){
            let opt = {query:{'search':this.searchValue}};
            return this.apiRequest.request('GET',this.GET_REQUEST_LIST, {}, opt);
        }
        return this.apiRequest.request('GET',this.GET_REQUEST_LIST);
        // return this.http.get(this.GET_REQUEST_LIST,this.httpPostOptions);
    }
    onRequestQuoteApprove(query):Observable<any>{
        let REQUEST_QUOTE_APPROVE = this.GET_REQUEST_QUOTE_APPROVE;
        REQUEST_QUOTE_APPROVE = REQUEST_QUOTE_APPROVE + "/" + query.uuid + "/" + query.status
        // let opt = {};
        // opt['query'] = query;
        return this.apiRequest.request('GET',REQUEST_QUOTE_APPROVE);
        // return this.apiRequest.request('GET',REQUEST_QUOTE_APPROVE,{},opt);
    }
    getRequestDetails(uuid):Observable<any>{
        let pathUrl = this.GET_REQUEST_LIST+'/' + uuid
        return this.apiRequest.request('GET',pathUrl);
        // return this.http.get(this.GET_REQUEST_LIST + '/' + uuid, this.httpPostOptions);
    }
    createRequest(data):Observable<any>{
        return this.apiRequest.request('POST',this.CREATE_REQUEST,data);
        // return this.http.post(this.CREATE_REQUEST, data, this.httpPostOptions);
    }
    updateRequest(data):Observable<any>{
        let pathUrl = this.UPDATE_REQUEST + '/' + data['uuid']
        return this.apiRequest.request('PUT',pathUrl,data);
        // return this.http.put(this.UPDATE_REQUEST + '/' + data['uuid'], data, this.httpPostOptions);
    }
    requestCredit(data):Observable<any>{
        return this.apiRequest.request('POST',this.REQUEST_CREDIT,data);
        // return this.http.post(this.REQUEST_CREDIT, data, this.httpPostOptions);
    }
    getRequestOwnerList(uuid,query):Observable<any>{
        // this.httpPostOptions.params = {"isActiveUser":isActiveUser}
        // let httpOptions = this.httpPostOptions;
        // let httpOptions = JSON.parse(JSON.stringify(this.httpPostOptions));
        // httpOptions.params = query;
        let opt = {};
        opt['query'] = query;
        return this.apiRequest.request('GET',this.GET_REQUEST_OWNER_LIST,{},opt);
        // return this.http.get(this.GET_REQUEST_OWNER_LIST, httpOptions);
    }
    getVideoAudioUrl(playerTitle):Observable<any>{
        let pathUrl = this.GET_PLAYER_URL+'/'+playerTitle
        return this.apiRequest.request('GET',pathUrl);
        // return this.http.get(this.GET_PLAYER_URL + '/' + playerTitle , this.httpPostOptions);
    }
    getInterviewList():Observable<any>{
        return this.apiRequest.request('GET',this.GET_INTERVIEW_URL);
        // return this.http.get(this.GET_INTERVIEW_URL , this.httpPostOptions)
    }
    getTransectionList():Observable<any>{
        return this.apiRequest.request('GET',this.GET_TRANSECTION_URL);
        // return this.http.get(this.GET_TRANSECTION_URL , this.httpPostOptions)
    }
    getTransectionListOfUser(uuid):Observable<any>{
        let pathUrl = this.GET_TRANSECTION_URL+'/'+uuid
        return this.apiRequest.request('GET',this.GET_TRANSECTION_URL);
        // return this.http.get(this.GET_TRANSECTION_URL + '/' + uuid , this.httpPostOptions)
    }
    getDropdownValues(){
        return this.apiRequest.request('GET',this.GET_DROPDOWN);
        // return this.http.get(this.GET_DROPDOWN, this.httpPostOptions)
    }
    sanctionRequest(uuid){
        let pathUrl = this.SET_SANCTION + '/' + uuid
        return this.apiRequest.request('PUT',pathUrl);
        // return this.http.put(this.SET_SANCTION + uuid, data, this.httpPostOptions);
    }

    updatePONumberRequest(uuid,request_owner_uuid,poNum){
        let pathUrl = this.UPDATE_REQUEST + '/' + uuid
        let data = {
            request_owner:request_owner_uuid,
            po:poNum
        }
        return this.apiRequest.request('PUT',pathUrl,data);
        // return this.http.put(this.SET_SANCTION + uuid, data, this.httpPostOptions);
    }
}